import ReactDOM from 'react-dom/client';
import { WebRoot } from './roots/WebRoot';
import reportWebVitals from './reportWebVitals.ts';
import { initSentry } from './integrations/sentry';

initSentry();

const DEV_TITLE_PREFIX = '[DEV] ';

const ensureDevTitlePrefix = () => {
  const currentTitle = document.title;
  if (!currentTitle) {
    return;
  }
  if (!currentTitle.startsWith(DEV_TITLE_PREFIX)) {
    document.title = `${DEV_TITLE_PREFIX}${currentTitle}`;
  }
};

if (import.meta.env.DEV) {
  ensureDevTitlePrefix();
  if (document.head) {
    const headObserver = new MutationObserver(() => {
      ensureDevTitlePrefix();
    });
    headObserver.observe(document.head, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }
}

// Render the app
const rootElement = document.getElementById('app');
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(<WebRoot />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
